import { get, getFile, post } from "api/apiBridges/httpBridge";
import { useCallback, useContext, useEffect, useState } from "react";
import Button from '@mui/material/Button';
import { Avatar, Box, Collapse, Dialog, Divider, List, ListItemButton, ListItemText, MenuItem, Modal, Paper, Select, Switch, TextField, Typography } from "@mui/material";
import { modal_style } from "styles/modal_style"
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { colors } from "styles/colors";
import { RadioDropList } from "components/RadioDropList";
import Carousel from "react-material-ui-carousel";
import Scrollbars from "rc-scrollbars";
import { ImagesCorusel, NumInputDesign, TextFeatureDesign, TextInput, TextInputDesign } from "./LittleComponents";
import { useDispatch, useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import _ from "lodash";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useLocalNotifications } from "components/Events";
import { setState } from "store/slices/dealTab";
import useOn from "components/socketLib/UseOn";
import { onChangeUploadImage } from "store/slices/uploadImage";
import { SocketContext } from "components/socketLib/ConnectorSocket";
import UserAvatar from "./UserAvatar";
import { DateMenu} from 'components/RangeDate';
import Loading from 'components/Load';

export default function DealClient({ds, deal_id}){

   const [loading, setLoading] = useState(true);

    /** @type {[any, Function]} */
  const [openGallery, setOpenGallery] = useState(undefined);
  /** @type {[any, Function]} */
  const [data, setData] = useState({});

  
  const dispatch = useDispatch();
  dispatch(setState({DealTab:deal_id}));


  useEffect(() => {
      const fetchData = async () => {
        try {
          const [responseData] = await Promise.all([
            get('Deal/getMore', {did: deal_id}),
          ])
  
  
          console.log("responseData", responseData)
          //Загрузка картинок 
          let tmp = []
          if (responseData?.data?.acceptance?.images) {
            await Promise.all(responseData.data.acceptance.images.map(async (el) => {
              let img = await getFile("png", {path:el})
              tmp.push({src:img, path:el})
            }))
            responseData.data.acceptance.images = tmp
          }
          tmp = []
          if (responseData?.data?.packaging?.images) {
            await Promise.all(responseData.data.packaging.images.map(async (el) => {
              let img = await getFile("png", {path:el})
              tmp.push({src:img, path:el})
            }))
            responseData.data.packaging.images = tmp
          }
          
          setData(responseData)        
  
        } catch (err) { console.log("err", err)
        } finally {
          setLoading(false);
        }
      };
      fetchData()
    }, [deal_id]);
  
    const { socket } = useContext(SocketContext);
    // const onSubmit = useCallback((data) => {
    //         dispatch(onChangeUploadImage(data));
    //     }, [dispatch]);

  //todo статусы

  if (loading) {
    return (<Loading></Loading>);
  }
  return (
      <div style={{height: "100%"}}>
        <Dialog
          open={openGallery !== undefined}
          maxWidth={false}
          PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
          onClose={() => { setOpenGallery(undefined) }}
        >
          <div style={{ height: '500px', width: '500px', padding: '12px', }}>
              <ImagesCorusel 
                key={openGallery} 
                items={openGallery === 'cim'? data?.data?.acceptance?.images || []: data?.data?.packaging?.images || []} 
                onChangeList={() => {}} 
                editable={false}
                onDel={() => {}}
              />
          </div>
  
        </Dialog>
        <div style={{
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }}>
          <Scrollbars
            autoHide
            style={{display: 'flex', justifyContent: "flex-start", flexDirection: "column", height: "85%"}}  
          >
            {/* Секция пользователя */}
            <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'15px'}>
              <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px"}}>
                  Основное
              </Typography>
              <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>
                <div style={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                  <Typography variant="body1" style={{ marginRight: 10, width: "auto"}}>
                    Ответственный:
                  </Typography>
                  <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <Typography variant="body1" sx={{ mr: "10px", color: 'black'}}>
                      {data.manager.fio}
                    </Typography>
                    <UserAvatar 
                      src={data.manager.avatarUrl} 
                      userData={data.manager} 
                      user_id={data.manager.userId} 
                      size={25}
                    />
                  </div>
                </div>
                <TextInputDesign
                  title = 'Телефон:'
                  val={data.user.phone} 
                  onChange={() => {}}  
                  align="right"
                  editable={false}
                />
  
              </Box>
            </Box>
            <div style={{ marginTop: '10px', width: '100%' }}>
              <Divider orientation="horizontal" sx={{borderBottomWidth: "10px", borderColor: "#e3e3e3"}} />
            </div>
  
            {/* Секция забор товара */}
            {
              <>  
                <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                  <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                    Забор товара
                  </Typography>
  
                  <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>
                    <TextInputDesign
                      title = 'Объем в работу:'
                      val={data?.data?.pickup?.volume} 
                      onChange={() => {}}  
                      align="right"
                      editable={false}
                    />
  
                    <TextInputDesign
                      title = 'Контакты:'
                      val={data?.data?.pickup?.contact} 
                      onChange={() => {}}  
                      align="right"
                      editable={false}
                    />
  
                    <TextInputDesign
                      title = 'Подписание груза:'
                      val={data?.data?.pickup?.sign} 
                      onChange={() => {}} 
                      align="right"
                      editable={false}
                    />
  
                    <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                      <Typography style={{ fontSize: "12pt" }}>
                        Дата поступления:
                      </Typography>
                      <DateMenu
                        date={data?.data?.logistic?.pickupDate ? new Date(data.data.logistic.pickupDate) : undefined} 
                        onChange={() => {}}
                        bgColor="#bddcde" 
                        textColor="#747474"
                      />
                    </Box>
  
                  </Box>
                </Box>
                <div style={{ marginTop: '10px', width: '100%' }}>
                    <Divider orientation="horizontal" sx={{borderBottomWidth: "10px", borderColor: "#e3e3e3"}} />
                </div>
              </>
            }
            {/* Секция Приемка */}
            {
              <>
                <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                  <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                    Приемка
                  </Typography>
                  <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>
  
                    <TextInputDesign
                      title = 'Тип места:'
                      val={data?.data?.acceptance?.placeType} 
                      onChange={() => {}}
                      align="right"
                      editable={false}
                    />
  
                    <NumInputDesign
                      title = 'Количество мест'
                      val={data?.data?.acceptance?.placeCount} 
                      onChange={() => {}}
                      align="right"
                      editable={false}
                    />
  
                    <div style={{display: 'flex', flexDirection: "row", justifyContent: 'flex-end'}}>
                      <Button
                        onClick={() => {setOpenGallery("cim")}}
                        variant="contained" 
                        disableElevation
                        sx={{
                          backgroundColor: '#bddcde',
                          borderRadius: '24px',
                          color: '#747474',
                          textTransform: 'none',
                          height: '26px',                        
                          '&:hover': {
                            backgroundColor: '#a5cdd0',
                          }
                        }} 
                      >
                        Галерея
                      </Button>
                    </div>
  
                    {/* <div style={{width: "100%", display: 'flex', flexDirection: 'row'}}>
                      <div style={{width: "50%"}}>
                        <ImagesCorusel key={"cim"} items={data?.data?.acceptance?.images || []} onChangeList={(e) => {handleFileUpload(e, "data.acceptance")}} onDel={(ind) => handleFileDel(ind, "data.acceptance")}/>
                      </div>
                      
                    </div> */}
  
                  </Box>
  
  
                </Box>
                <div style={{ marginTop: '10px', width: '100%' }}>
                    <Divider orientation="horizontal" sx={{borderBottomWidth: "10px", borderColor: "#e3e3e3"}} />
                </div>
              </>
            }
            {/* Секция сортировки */}
            {
              <>
                <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                  <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                    Сортировка
                  </Typography>
                  <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>
  
                    <TextInputDesign
                      title = 'SKU:'
                      val={data?.data?.sku}
                      onChange={(e) => {}}
                      align="right"
                      editable={false}
                    />
  
                    <TextInputDesign
                      title = 'Товара:'
                      val={data?.data?.units}
                      onChange={(e) => {}}
                      align="right"
                      editable={false}
                    />
  
                    <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                      <Typography style={{ fontSize: "12pt" }}>
                        Начало сортировки:
                      </Typography>
                      <DateMenu
                        date={data?.data?.sort?.startDate ? new Date(data.data.sort.startDate) : undefined} 
                        onChange={() => {}}
                        bgColor="#bddcde" 
                        textColor="#747474"
                      />
                    </Box>
  
                    <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                      <Typography style={{ fontSize: "12pt" }}>
                        Окончание сортировки:
                      </Typography>
                      <DateMenu
                        date={data?.data?.sort?.finishDate ? new Date(data.data.sort.finishDate) : undefined} 
                        onChange={() => {}}
                        bgColor="#bddcde" 
                        textColor="#747474" 
                      />
                    </Box>
  
                  </Box>
                </Box>
                <div style={{ marginTop: '10px', width: '100%' }}>
                    <Divider orientation="horizontal" sx={{borderBottomWidth: "10px", borderColor: "#e3e3e3"}} />
                </div>
              </>
            }
            {/* Секция упаковки */}
            {
              <>
                <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                  <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                    Упаковка
                  </Typography>
                  <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>
                    
                    <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                      <Typography style={{ fontSize: "12pt" }}>
                        Начало упаковки:
                      </Typography>
                      <DateMenu
                        date={data?.data?.packaging?.startDate ? new Date(data.data.packaging.startDate) : undefined} 
                        onChange={() => {}}
                        bgColor="#bddcde" 
                        textColor="#747474"
                      />
                    </Box>
  
                    <Box sx={{width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                      <Typography style={{ fontSize: "12pt" }}>
                        Окончание упаковки:
                      </Typography>
                      <DateMenu
                        date={data?.data?.packaging?.finishDate ? new Date(data.data.packaging.finishDate) : undefined} 
                        onChange={() => {}}
                        bgColor="#bddcde" 
                        textColor="#747474"
                      />
                    </Box>
  
                    <div style={{display: 'flex', flexDirection: "row", justifyContent: 'flex-end'}}>
                      <Button
                        onClick={() => {setOpenGallery("pim")}}
                        variant="contained" 
                        disableElevation
                        sx={{
                          backgroundColor: '#bddcde',
                          borderRadius: '24px',
                          color: '#747474',
                          textTransform: 'none',
                          height: '26px',                        
                          '&:hover': {
                            backgroundColor: '#a5cdd0',
                          }
                        }} 
                      >
                        Галерея
                      </Button>
                    </div>
  
                    {/* <div style={{width: "100%", display: 'flex', flexDirection: 'row'}}>
                      <div style={{width: "50%"}}>
                        <ImagesCorusel key={"pim"} items={data?.data?.packaging?.images || []} onChangeList={(e) => {handleFileUpload(e, "data.packaging")}} onDel={(ind) => handleFileDel(ind, "data.packaging")} />
                      </div>
                    </div>                */}
  
                  </Box>
                </Box>
                <div style={{ marginTop: '10px', width: '100%' }}>
                    <Divider orientation="horizontal" sx={{ borderBottomWidth: "10px", borderColor: "#e3e3e3" }} />
                </div>
              </>
            }
            {/* Секция логистики */}
            {
              <>
                <Box mb={2} margin={"5px"} padding={"5px"} marginLeft={'20px'}>
                  <Typography variant="h2" sx={{ color: '#208f84', textTransform: 'uppercase', mb: "10px" }}>
                    Логистика
                  </Typography>
                  <Box sx={{width: "98%", display: 'flex', flexDirection: 'column', marginLeft: "2%", gap: "7px"}}>
  
                    <TextInputDesign
                      title = 'Транзитный склад'
                      val={data?.warehouse_tranzit} 
                      onChange={() => {}} 
                      editable={false}
                    />
  
                    <TextInputDesign
                      title = 'Склад назначения'
                      val={data?.warehouse_market} 
                      onChange={() => {}} 
                      editable={false}
                    />
  
                    <TextInputDesign
                      title = 'Тип отгрузки'
                      val={data?.data?.logistic?.type} 
                      onChange={(e) => {}}
                      editable={false}
                    />
  
                    <NumInputDesign
                      title = 'Количество мест'
                      val={data?.data?.logistic?.placeCount} 
                      onChange={(e) => {}} 
                    />
  
                    <NumInputDesign
                      title = 'Количество ед.'
                      val={data?.data?.logistic?.itemCount} 
                      onChange={(e) => {}}  
                    />
                  </Box>
                </Box>
                <div style={{ marginTop: '10px', width: '100%' }}>
                    <Divider orientation="horizontal" sx={{ borderBottomWidth: "10px", borderColor: "#e3e3e3" }} />
                </div>
              </>
            }
            
          </Scrollbars>
        </div>
      </div>
    );
}

export function Additional_feature({type, val, name, title, onChange, values}) {
  switch (type) {
    case "fix":
    case "func":
      return <Typography variant="h4">{title}: {val}</Typography>
    case "input":
      return(
        <TextInput 
          title={title} 
          val={val}
          onChange={(e) => onChange(e)} 
        />
      )
    case "enum":
       return (
        <div style={{width: "48%", marginTop: 5, display:'flex', flexDirection:'row', justifyContent: 'flex-start', alignItems: "center"}}>
          <Typography variant="h4" >{title}</Typography>
          <Select
            style={{width:"100%"}}
            value={val}
            // label="Возможные значения"
            onChange={(e) => onChange(e)} 
          >
            {values? values.map((v) => {return(<MenuItem value={v.val}>{v.name} ({v.val})</MenuItem>)}): <></>}
          </Select>
        </div>
        )
  }
}